import TileLayer from "ol/layer/Tile"
import TileArcGISRest from 'ol/source/TileArcGISRest'
import OSM from "ol/source/OSM"
import XYZ from 'ol/source/XYZ'
import {getTopLeft, getWidth} from "ol/extent";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import WMTS from "ol/source/WMTS";

let mapType = 3        //0表示部署的离线瓦片地图，1表示OSM,2表示使用Arcgis在线午夜蓝地图服务
const crs = "EPSG::4326";
const tileMatrixLabels = "";
const projectionExtent = [-180, -90, 180, 90];
const size = getWidth(projectionExtent) / 256;
let resolutions = [];
let matrixIds = [];
for (let z = 0; z < 21; z++) {
  if (crs === "EPSG::4326" || crs === "4326") {
    resolutions[z] = size / Math.pow(2, z);
  } else {
    resolutions[z] = size / Math.pow(2, z + 1);
  }
  matrixIds[z] = tileMatrixLabels + z;
}
const origin = getTopLeft(projectionExtent);

const key = "0b7d509b3c03694118feae274bf45af8";

var streetMap = function (layerType) {
  var mapLayer = null;
  switch (mapType) {
    case 0:
      mapLayer = new TileLayer({
        source: new XYZ({
          url: 'http://127.0.0.1:7080/streetmap/shenzhen/{z}/{x}/{y}.jpg'
        })
      });
      break;
    case 1:
      mapLayer = new TileLayer({
        source: new OSM()
      });
      break;
    case 2:
      mapLayer = new TileLayer({
        source: new TileArcGISRest({
          url: 'https://map.geoq.cn/ArcGIS/rest/services/ChinaOnlineCommunity/MapServer'
        })
      });
      break;
    case 3:
      mapLayer = new TileLayer({
        source: new WMTS({
          url: "http://t0.tianditu.gov.cn/" + layerType + "_c/wmts?tk=" + key,
          layer: layerType,
          style: "default",
          matrixSet: "c",
          format: "tiles",
          wrapX: true,
          tileGrid: new WMTSTileGrid({
            origin: origin,
            resolutions: resolutions,
            matrixIds: matrixIds,
          }),
        })
      });
      break;
  }
  return mapLayer;
}

//设置地图第一次进入显示的中心位置 配置
var mapConfig = {
  x: 123.128836,     //中心点经度和纬度
  y: 41.68764,
  zoom: 12,          //地图缩放级别
  maxZoom: 18,          //地图缩放级别
  minZoom: 11,          //地图缩放级别
  streetZoom: 16,
  streetMap: streetMap,
};

export default mapConfig
